module.exports = __webpack_public_path__ + "img/laboratorio_9-16_360.1bb450af.webp";